import { mountVueWithProps } from '../../common/utils/vue';
import FollowApp from '../../supervising_doctors/FollowApp';

document.addEventListener('DOMContentLoaded', () => {
  mountVueWithProps({
    element: document.querySelector('.js-supervising_doctors-follow'),
    component: FollowApp
  });
});
